import { combineReducers } from "redux";
import { NoticReducer } from "./NotifactionReducer";
import { UserReducer } from "./UserReducer";
import { CategoryReducer } from "./CategoryReducer";
import { ContactReducer } from "./ContactReducer";
import { NewsletterReducer } from "./NewsletterReducer";

export default combineReducers({
    NoticStateData: NoticReducer,
    UserStateData : UserReducer,
    CategoryStateData : CategoryReducer,
    ContactStateData: ContactReducer,
    NewsletterStateData : NewsletterReducer,
})